// @flow strict
import Plotly from 'views/custom-plotly';
import createPlotlyComponent from 'react-plotly.js/factory';

const Plot = createPlotlyComponent(Plotly);

export default Plot;
